/** @format */

import React from 'react';
import About from './components/About';
import Contact from './components/Contact';
import Navbar from './components/Navbar';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Blog from './components/Blog';
import Logos from './components/Logos';

export default function HomePageView() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Logos />
      <Projects />
      <Skills />
      <Blog />
      <Contact />
      <Logos />
    </main>
  );
}
